export default "__VITE_ASSET__DJocPZ9I__"